export const enum SlumberActionType {
    FallAsleep = 'SLUMBER/FALL_ASLEEP',
    WakeUp = 'SLUMBER/WAKE_UP',
}

export type FallAsleepAction = ReturnType<typeof fallAsleep>;
export const fallAsleep = () => ({
    type: SlumberActionType.FallAsleep,
});

export type WakeUpAction = ReturnType<typeof wakeUp>;
export const wakeUp = () => ({
    type: SlumberActionType.WakeUp,
});
